import { render, staticRenderFns } from "./associatedDocuments.vue?vue&type=template&id=4a7fc860&scoped=true"
import script from "./associatedDocuments.vue?vue&type=script&lang=js"
export * from "./associatedDocuments.vue?vue&type=script&lang=js"
import style0 from "./associatedDocuments.vue?vue&type=style&index=0&id=4a7fc860&prod&ref=stylesheet%2Fscss&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a7fc860",
  null
  
)

export default component.exports